import "./src/styles/app.scss"
import "./src/styles/pagination.scss"
import wrapWithProvider from "./wrap-with-provider"
export const wrapRootElement = wrapWithProvider